var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from 'react';
import i18next from 'i18next';
import { push } from 'connected-react-router';
import { unwrapResult } from '@reduxjs/toolkit';
import { executeRequest } from '~utils/executeRequest';
import { resetProviderId, templateInfoSelector } from '~slices/top-ranking';
import { getBp, startPolling, useResponseObjectSelector } from '~slices/bp';
import { isAuthenticatedSelector } from '~slices/auth';
import { useAppDispatch } from '~store';
import { useStructuredSelector } from '~hooks';
import { getCashOut } from '~slices/cashOut';
import { deleteFullBetslip } from '~store/slices/betslip';
import { setIsMobileTopRankingHidden } from '~slices/view';
import { getTestId } from '~utils/getTestId';
import { getPathWithLanguageCode } from '~utils/languageInURL/getPathWithLanguageCode';
import { BpHeader } from './BpHeader';
export var BPRegistration = function () {
    var dispatch = useAppDispatch();
    var _a = useState(''), formAction = _a[0], setFormAction = _a[1];
    var _b = useState(''), inputValue = _b[0], setInputValue = _b[1];
    var submit = useRef(null);
    var iframeRef = useRef(null);
    var providers = useResponseObjectSelector();
    var _c = useStructuredSelector({
        isAuthenticated: isAuthenticatedSelector,
        templateInfo: templateInfoSelector,
    }), isAuthenticated = _c.isAuthenticated, _d = _c.templateInfo, requestId = _d.requestId, template = _d.template, providerId = _d.providerId, ticketId = _d.ticketId, linkType = _d.linkType;
    var currentProvider = providers === null || providers === void 0 ? void 0 : providers.find(function (item) { return item.id === providerId; });
    var restartPolling = function () {
        if (isAuthenticated) {
            dispatch(getBp(true))
                .then(unwrapResult)
                .then(function (res) {
                if (res.requestId) {
                    dispatch(startPolling(res.requestId));
                }
            });
        }
    };
    var getBPLoginTemplateLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, executeRequest({
                        url: "bp/v1/bp-integrator/template/".concat(template),
                        options: {
                            method: 'GET',
                        },
                        params: __assign(__assign(__assign(__assign({}, (providerId && { providerId: providerId })), (ticketId && { ticketId: ticketId })), (requestId && { requestId: requestId })), (linkType && { linkType: linkType })),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/];
                    }
                    data = response.data;
                    setFormAction(data.templateUrl || '');
                    setInputValue(data.jwtToken || '');
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (providerId && (ticketId || template || linkType)) {
            getBPLoginTemplateLink();
        }
    }, [providerId, template, ticketId, linkType]);
    var handleSubmitAndSubscribe = function () {
        var _a;
        if (formAction && inputValue) {
            (_a = submit === null || submit === void 0 ? void 0 : submit.current) === null || _a === void 0 ? void 0 : _a.click();
            var handleMessage_1 = function (event) {
                if (formAction.indexOf(event.origin) === 0) {
                    if (event.data === 'close') {
                        // dispatch(push(location?.state?.from || '/'));
                        dispatch(getCashOut());
                        dispatch(resetProviderId());
                    }
                    if (event.data === 'refresh') {
                        getBPLoginTemplateLink();
                    }
                    if (event.data === 'registration_success') {
                        dispatch(resetProviderId());
                        restartPolling();
                    }
                    if (event.data === 'clear') {
                        dispatch(deleteFullBetslip({ eventsType: 'betSlip' }));
                    }
                    if (event.data === 'close_go_live') {
                        dispatch(resetProviderId());
                        dispatch(push(getPathWithLanguageCode('/home/all/live')));
                        dispatch(getCashOut());
                    }
                    if (event.data === 'close_go_edit_data') {
                        dispatch(push(getPathWithLanguageCode('/my-account/general')));
                    }
                    if (event.data.open_partner_site) {
                        var link = event.data.open_partner_site;
                        window.open(link, '_blank');
                    }
                }
            };
            window.addEventListener('message', handleMessage_1);
            return function () {
                window.removeEventListener('message', handleMessage_1);
            };
        }
        return function () { return undefined; };
    };
    useEffect(function () {
        var _a;
        if (iframeRef.current && i18next.language) {
            (_a = iframeRef.current.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({
                type: 'CHANGE_LANGUAGE',
                payload: i18next.language,
            }, '*');
        }
    }, [iframeRef.current, i18next.language]);
    useEffect(function () {
        var unsubscribe = handleSubmitAndSubscribe();
        return unsubscribe;
    }, [formAction, inputValue]);
    return (React.createElement(React.Fragment, null,
        linkType && React.createElement(BpHeader, { provider: currentProvider }),
        React.createElement("form", { name: "templateform", target: "hidden_iframe", action: formAction, method: "post", style: { display: 'none' } },
            React.createElement("input", { type: "text", name: "jwt", defaultValue: inputValue }),
            React.createElement("input", { type: "submit", ref: submit })),
        React.createElement("iframe", { src: "", style: {
                flexGrow: 1,
                border: 'none',
                width: '100%',
                zIndex: 4,
            }, onLoad: function () {
                setTimeout(function () {
                    dispatch(setIsMobileTopRankingHidden(false));
                }, 500);
            }, ref: iframeRef, name: "hidden_iframe", title: "bpRegistration", "data-testid": getTestId('SDK') })));
};
